/* global translate */
import React from 'react';
import './index.css';

import subDays from "date-fns/subDays";
import DatePicker from "react-datepicker";
import "./react-datepicker.css";

const { rxgetLocal } = global.rootRequire('classes/request')
const { rxaget, rxChangeSlug } = global.rootRequire('classes/ulti')
const CreateCalendarComponent = require('./CreateCalendar').default

const DetailCalendarComponent = require('./DetailCalendar').default

const days = ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7']

const daysStr = ['Chủ Nhật', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7']
const daysEngStr = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']

const months = ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12']
const monthsEng = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
const locale = {
  localize: {
    day: n => days[n],
    month: n => months[n]
  },
  formatLong: {
    date: () => 'mm/dd/yyyy'
  }
}

const isWeekday = (date) => {
  // const day = date.getDay()
  // return day !== 0 && day !== 6;
  return true
}

export function subString(str, pos) {
  pos = pos || 33
  let result = ''
  if (str && typeof (str) === 'string' && str.length > pos) {
    result = str.substr(0, pos) + ' ...'
  } else {
    result = str
  }

  return result
}


export function convertUnixTimeDate(datestr) {
  return Math.floor((new Date(datestr).getTime()) / 1000)
}

export function convertTimeToDate(dateunix, numday) {
  let newDate = ((dateunix + 25200) - (dateunix + 25200) % (86400)) - 25200

  return (numday) ? newDate - (numday * 86400) : newDate
}

export function convertUnixToDate(UNIX_timestamp, lang) {
  var a = new Date(UNIX_timestamp * 1000)
  var months = ['tháng 1', 'tháng 2', 'tháng 3', 'tháng 4', 'tháng 5', 'tháng 6', 'tháng 7', 'tháng 8', 'tháng 9', 'tháng 10', 'tháng 11', 'tháng 12']
  var year = a.getFullYear()
  var month = (lang === 'en') ? monthsEng[a.getMonth()] : months[a.getMonth()]
  var date = a.getDate()
  var day = a.getDay()

  let timenow = new Date(Math.floor(Date.now()))
  var yearnow = timenow.getFullYear()

  var time = daysStr[day] + ', ' + date + ' ' + month

  if (yearnow !== year) {
    time = daysStr[day] + ', ' + date + ' ' + month + ' ' + year
  }

  if (lang === 'en') {
    time = daysEngStr[day] + ', ' + ' ' + month + ' ' + date
  }

  return time;
}

export function convertUnixToTime(UNIX_timestamp) {
  var date = new Date(UNIX_timestamp * 1000)
  var monthStr = ("0" + (Number(date.getMonth()) + 1)).substr(-2)
  var dayStr = ("0" + date.getDate()).substr(-2)

  var hour = ("0" + date.getHours()).substr(-2);
  var minutes = ("0" + date.getMinutes()).substr(-2);

  if ((hour + ':' + minutes) !== '00:00') {
    return hour + ':' + minutes
  } else {
    return dayStr + '/' + monthStr
  }
}

export function convertToDateStr(UNIX_timestamp, type) {
  var a = new Date(UNIX_timestamp * 1000)
  if (type === 'date') {
    a = UNIX_timestamp || new Date()
  } else if (type === 'unix') {
    a = new Date(UNIX_timestamp)
  }

  var year = a.getFullYear()
  var monthStr = ("0" + (Number(a.getMonth()) + 1)).substr(-2)
  var dayStr = ("0" + a.getDate()).substr(-2)
  var hour = ("0" + a.getHours()).substr(-2)
  var minutes = ("0" + a.getMinutes()).substr(-2)

  return year + '-' + monthStr + '-' + dayStr + ' ' + hour + ':' + minutes
}

Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}

function getFirstDayOfMonth() {
  let date = new Date()
  let firstDayMonth = new Date(date.getFullYear(), date.getMonth(), 1)
  return firstDayMonth
}

function getLastDayOfMonth() {
  let date = new Date()
  let lastDayMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999)
  return lastDayMonth
}


// Create component class for calendar
class Calendar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      objData: {},
      objDate: {},
      detail: {},
      showCreateCalendar: false,
      showEditCalendar: false,
      page: 1,

      startDateStr: null,
      endDateStr: null
    }

    this.blockScroll = false

    this.onChange = this.onChange.bind(this)


    let date = new Date();
    let firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    this.firstMonthDateTime = firstDay.getTime()
    this.lastMonthDateTime = (Math.floor(lastDay.getTime() / 1000) + 86399)*1000

    let language = localStorage.getItem('netaLang') || 'vi'
    this.language = language.replace(/"/g, '')
    this.locale =  locale
    if (language.indexOf('en') !== -1) {
      this.locale = 'en'
    }

  }

  componentDidMount() {
    this.getListCalendar()
  }

  handleScroll(event) {
    const { scrollHeight, scrollTop, clientHeight } = event.target;
    const scroll = scrollHeight - scrollTop - clientHeight

    if (scroll < 1) {
      let page = this.state.page

      if (!this.blockScroll) {
        this.blockScroll = true

        this.setState({
          page: page + 1
        }, () => {
          this.getListCalendar()

          setTimeout(() => {
            this.blockScroll = false
          }, 500)
        })
      }
    }
  }

  getListCalendar() {
    let objData = this.state.objData
    let objDate = this.state.objDate
    let page = this.state.page

    let base_api_neta = global.rxu.config.base_api_neta
    let calendar_link = base_api_neta + '/api/calendar'


    let params = {
      page: page,
      size: 300
    }

    let netaAuthUser =  global.rxu.json(rxgetLocal('rxuserneta'), { user:{} })

    if (rxaget(netaAuthUser, 'user.token', '')) {
      // params['tc_token'] = '01629d751aa0fbf347e9be116b2d9e239423vTjf'// rxaget(netaAuthUser, 'user.token', '')

      if (!this.state.startDateStr) {
        let newDate = new Date()
        params.start_time = convertToDateStr(getFirstDayOfMonth(), 'date')
        params.end_time = convertToDateStr(getLastDayOfMonth(), 'date')
      }

      if (this.state.startDateStr) {
        params.start_time = convertToDateStr(this.state.startDateStr.setHours(0, 0, 0, 0), 'unix')
      }

      if (this.state.endDateStr) {
        params.end_time = convertToDateStr(this.state.endDateStr.setHours(23, 59, 59, 999), 'unix')
      }

      // Make params
      let tempBody = ''
      for (let property in params) {
        if (params.hasOwnProperty(property)) {
          tempBody += `${property}=${params[property]}&`
        }
      }

      let headers = { 'Content-Type': 'application/json', 'TC-Token': rxaget(netaAuthUser, 'user.token', '') }

      fetch(calendar_link + '?' + tempBody, {
        method: 'GET',
        headers: headers
      }).then(res => res.json()).then((json) => {
        if (json && json.items && json.items.constructor === Array && json.items.length > 0) {
          let arrItems = []
          for (let item of json.items) {
            item.time_start = convertUnixTimeDate(item.start_time)
            arrItems.push(item)
          }

          arrItems = arrItems.sort((a, b) => a.time_start - b.time_start)

          for (let item of arrItems) {
            item.time_end = convertUnixTimeDate(item.end_time)

            item.dateunix = convertTimeToDate(item.time_start)

            convertUnixToDate(item.dateunix)

            if (objDate && !objDate[item.dateunix]) {
              objDate[item.dateunix] = 1
            }

            if (item && item.recipients && item.recipients.constructor === Array && item.recipients.length > 0) {
              let findOwner = item.recipients.find(o => o.owner === true)
              if (findOwner && findOwner.full_name) {
                item.owner = findOwner.full_name
              }
            }

            if (!objData[item.dateunix]) {
              objData[item.dateunix] = []
            }

            objData[item.dateunix].push(item)
          }

          this.setState({
            objData: objData
          })
        }

      }).catch(error => console.log(error))
    }
  }


  onChange(dateSelected) {
    let start = new Date(dateSelected.setHours(0, 0, 0, 0))
    let end = new Date(dateSelected.setHours(23, 59, 59, 999))

    this.setState({
      startDateStr: start,
      endDateStr: end,
      page: 1,
      objData: {},
      // objDate: {}
    }, () => {
      this.getListCalendar()
    })
  }

  createCalendar() {
    this.setState({
      showCreateCalendar: true
    })
  }

  backFunc(flagUpdate) {
    // this.setState({
    //   showCreateCalendar: false,
    //   showEditCalendar: false,
    //   startDateStr: null,
    //   endDateStr: null,
    //   page: 1,
    //   detail: {},
    //   objData: {},
    //   objDate: {}
    // }, () => {
    //   this.getListCalendar()
    // })
    let updateState = {
      showCreateCalendar: false,
      showEditCalendar: false,
      page: 1,
      detail: {}
    }

    if (flagUpdate) {
      updateState['objData'] = {}
    }

    this.setState(updateState, () => {
      if (flagUpdate) {
        this.getListCalendar()
      }
    })
  }

  backFuncReset(timeChoosed) {
    let updateState = {
      showCreateCalendar: false,
      showEditCalendar: false,
      startDateStr: null,
      endDateStr: null,
      page: 1,
      detail: {},
      objData: {},
      objDate: {}
    }

    this.setState(updateState, () => {
      this.getListCalendar()
      
      setTimeout(() => {
        try {
          if (timeChoosed) {
            let dateStrChoosed = new Date(timeChoosed).getTime()/1000
            let dateTimeChoosed = ((dateStrChoosed + 25200) - (dateStrChoosed + 25200) % (86400)) - 25200
            this.setState({
              startDateStr: new Date(dateTimeChoosed * 1000)
            })
          }
        } catch(e) {}
      }, 500)
    })
  }

  backFuncDel(objDel) {
    let objData = this.state.objData
    let updateState = {
      showCreateCalendar: false,
      showEditCalendar: false,
      page: 1,
      detail: {}
    }
    
    if (objDel && objDel.id && objDel.dateunix && objData && objData[objDel.dateunix]) {
      let indexCalendar = objData[objDel.dateunix].findIndex(x => x.id === objDel.id)
      if (indexCalendar > -1) { 
        objData[objDel.dateunix].splice(indexCalendar, 1)
        updateState['objData'] = objData
      }
    }

    this.setState(updateState)
  }

  editCalendarFunc() {
    this.setState({
      showCreateCalendar: false,
      showEditCalendar: true
    })
  }

  handleClickOutside(e) {
    let arrOutside = ['zchat_popupcenter_calendar']
    if (e && e.target && e.target.className && arrOutside.indexOf(e.target.className) !== -1) {
      this.props.closeCalendar()
    }
  }

  clickDetail(calendar) {
    this.setState({
      showCreateCalendar: true,
      detail: calendar
    })
  }

  render() {
    let arrDates = []
    Object.keys(this.state.objDate).forEach(od => {
      if (od) {
        arrDates.push(new Date(od * 1000))
      }
    })

    this.highlightWithRanges = [{ 'react-datepicker__day--highlighted-custom-1': arrDates }]

    let startDateStr = null
    if (!this.state.startDateStr) {
      startDateStr = new Date()
    } else {
      startDateStr = this.state.startDateStr
    }

    let dateTimeNow = convertUnixTimeDate(startDateStr)
    let dateNow = ((dateTimeNow + 25200) - (dateTimeNow + 25200) % (86400)) - 25200

    return (
      <div className="zchat_popup_calendar" onMouseDown={e => this.handleClickOutside(e)}>
        <div className="zchat_popup_calendar_bg"></div>
        <div className="zchat_popup_calendar_main">
          <div className="zchat_popupcenter_calendar">
            {(!this.state.showCreateCalendar && !this.state.showEditCalendar) && <div className="zchat_popup_calendar_mainbox">
              <div className="zchat_popup_calendar_header">
                <div className="zchat_popup_calendar_title">{translate('Calendar')}</div>
                <div className="zchat_popup_calendar_btn_right">
                  <img alt="" src="./images/default/icons/icon-add.svg" onClick={e => this.createCalendar()} />
                </div>
              </div>

              <div className="zchat_popup_calendar_body">
                <div className="calendar-container" style={{ "background": "#f0f4f5" }}>
                  <div className="calendar-box">
                    <DatePicker
                      selected={startDateStr}
                      onChange={this.onChange}
                      highlightDates={this.highlightWithRanges}
                      dayClassName={(date) =>
                        (date.getTime() >= this.firstMonthDateTime && date.getTime() < this.lastMonthDateTime) ?  undefined : "class-calendar-month"
                      }
                      locale={this.locale}
                      filterDate={isWeekday}
                      startDate={startDateStr}
                      endDate={this.state.endDateStr}
                      // selectsRange
                      inline
                    />

                    <div className='calendar-list' onScroll={e => this.handleScroll(e)}>
                      <div className='row-calendar-main'>
                        <div className='row-calendar-date'>
                          <span className='row-calendar-date__left'>{convertUnixToDate(dateNow, this.language)}</span>
                          <span className='row-calendar-date__right'></span>
                        </div>

                        {(this.state.objData[dateNow]) && this.state.objData[dateNow].map((calendarItem, calendarIndex) => {
                          let dateTime = calendarItem.time_start
                          
                          return <div key={calendarIndex} className='row-calendar-item' onClick={e => this.clickDetail(calendarItem)}>
                            <div className='row-calendar-body'>
                              <div className='row-calendar-title prevent-select'>
                                {subString(calendarItem.title, 255)}
                              </div>
                              {calendarItem.owner && <div className='row-calendar-creator'>
                                <img className="icon_label_calendar" alt="" src="./images/default/icons/icon-user-admin.svg" />
                                <span>{calendarItem.owner}</span>
                              </div>}
                              <div className='row-calendar-time'>
                                <img className="icon_label_calendar icon-time-recent" alt="" src="./images/default/icons/icon-recent-org.svg" />
                                <span>{convertUnixToTime(calendarItem.time_start)} - {convertUnixToTime(calendarItem.time_end)}</span>
                              </div>
                              {calendarItem.link && <div className='row-calendar-link'>
                                <img className="icon_label_calendar icon-time-recent" alt="" src="./images/default/icons/icon-link-org.svg" />
                                <span>{calendarItem.link}</span>
                              </div>}
                            </div>
                          </div>
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>}

            {(this.state.showCreateCalendar && this.state.detail && !this.state.detail.id) && <CreateCalendarComponent
              backFunc={e => this.backFunc(e)}
              startDate={dateNow}
            />}

            {(this.state.showEditCalendar && this.state.detail && this.state.detail.id) && <CreateCalendarComponent
              backFunc={e => this.backFunc(e)}
              backFuncReset={(timeChoosed) => this.backFuncReset(timeChoosed)}
              detail={this.state.detail}
              flagEdit={this.state.showEditCalendar}
            />}

            {(this.state.showCreateCalendar && this.state.detail && this.state.detail.id) && <DetailCalendarComponent
              backFunc={e => this.backFunc()}
              backFuncDel={objDetail => this.backFuncDel(objDetail)}
              editCalendarFunc={e => this.editCalendarFunc()}
              detail={this.state.detail}
            />}
          </div>
        </div>
      </div>
    )
  }
}

export default Calendar;